import { getTenant, TENANTS } from 'src/utils/tenant';

import { Api } from './generated/ApiClient';

/**
 * Learning Backend API Client
 *
 * Configured instance of the API client for the Learning App backend.
 * This client is automatically generated from the Swagger specification.
 *
 * @example
 * ```typescript
 * import { apiClient } from '@/api/client';
 *
 * // Fetch learning objects
 * const response = await apiClient.adobe.getLearningObjects({
 *   searchRequest: { pageLimit: 10 }
 * });
 * ```
 */

export const apiClient = new Api({
  baseUrl: '/gateway/api/learning-app',
  baseApiParams: {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-lms-tenant': getTenant()?.key ?? TENANTS.COMMUNITY.key,
    },
    format: 'json',
  },
});

export { Api } from './generated/ApiClient';
